import React from "react";
import { GenericDialog } from "../../components/generic/GenericDialog";
import { Box, Button, Stack, Typography } from "@mui/material";
import { GenericCircleIcon } from "../../components/generic/GenericCircleIcon";
import { Trash } from "@phosphor-icons/react";
import { NeedHelp } from "../../components/ui/topbar/generic/GenericDialogFooter";

export const DeleteAccountDialog = (props) => {
  const {
    openDeleteAccountConfirmationDialog,
    setOpenDeleteAccountConfirmationDialog,
    handleDeleteAccount
  } = props;

  return (
    <GenericDialog
      title={'Delete Account'}
      openDialog={openDeleteAccountConfirmationDialog}
      handleClose={() => setOpenDeleteAccountConfirmationDialog(false)}
      width={'550px'}
    >
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} mb={2}>
        <GenericCircleIcon color={'primary.main'}>
          <Trash size={96} weight="thin" />
        </GenericCircleIcon>
      </Box>
      <Stack gap={3} alignItems={'center'}>
        <Typography variant="subtitle1" textAlign={'center'}>This action cannot be undone.<br></br>Are you sure you want to continue?</Typography>
        <Stack direction={{ xs: 'column', md: 'row' }} gap={1}>
          <Button variant="outlined" sx={{ width: { xs: '100%', sm: '250px' } }} onClick={() => setOpenDeleteAccountConfirmationDialog(false)}>Cancel</Button>
          <Button variant="contained" color="error" sx={{ width: { xs: '100%', sm: '250px' } }} onClick={() => handleDeleteAccount()}>Delete Account</Button>
        </Stack>
        <NeedHelp />
      </Stack>
    </GenericDialog>
  )
};